// this file is generated by update_shopify_store_data.py at 2025-09-30 20:31:59.320491
var courses = [
    {
        "course_id": "F02CDBC1-3F54-EF11-998F-005056A7D719",
        "course_version": 1,
        "name": "S.T.A.B.L.E. Program Bridge to the 7th Edition Training for Instructors \u2013 with S.T.A.B.L.E. Foundations",
        "course_type": 32,
        "author_information": "",
        "description": "The purpose of this curriculum is to orient registered lead and support instructors to the new 7th edition and the new S.T.A.B.L.E. Foundations course. Additionally, this course explains changes to student testing, updates to the instructor portal, and new requirements for submitting student rosters.",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1E8E3774-CEC9-E511-82AF-005056B150D3",
                "course_category_name": "Diagnostic Tests & Examinations",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CNE - Continuing Nurse Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DC4CE665-F455-EF11-9990-005056A7327D",
                "course_category_name": "HSTM - The S.T.A.B.L.E. Program Online - Instructor Bridge - (2 of 3 Courses for CURRICULUM ONLY)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "27BB2B08-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Patient Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF64E5F4-3674-EA11-A221-005056B14D10",
                "course_category_name": "The S.T.A.B.L.E. Program Online",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2EDDE197-8C59-EF11-9993-005056A725AD",
                "course_category_name": "HSTM - The S.T.A.B.L.E. Program Online - Instructor Bridge - (This is the CURRICULUM ONLY)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "496E0940-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CME - Continuing Medical Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Obstetrics and Gynecology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DFE5D158-40B4-DF11-9F38-0015171C5BB1",
                "course_category_name": "CE - Continuing Education",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AFBFC50C-4AFE-11DE-ADE3-0015171C5BB3",
                "course_category_name": "Online CME",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A8BD2E52-FCDD-11DC-AFB4-0015171353BD",
                "course_category_name": "Online CE",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "975A148E-A6FF-E611-A64B-005056B1522B",
                "course_category_name": "Obstetric Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EE06D56C-3874-EA11-A221-005056B14D10",
                "course_category_name": "HSTM - The S.T.A.B.L.E. Program Online",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "F210390E-9FFD-EE11-998C-005056A7F5E9",
                "course_version": 8,
                "name": "S.T.A.B.L.E. Foundations",
                "course_type": 1,
                "author_information": "Kristine A. Karlsen, PhD, NNP-BC, FAAN, Neonatal Nurse Practitioner, S.T.A.B.L.E. Program Author and Founder, and S.T.A.B.L.E. Program Director. \r\n\r\nS.T.A.B.L.E. Foundations was reviewed and evaluated by a team of maternal-fetal medicine, obstetric, and neonatology experts.",
                "description": "In this four-part curriculum we will cover the following, Part 1 will define implicit bias and how biases and stereotypes affect decision-making in the clinical setting. Maternal conditions that may impact fetal and neonatal health are also discussed.  \r\nParts 2 and 3 will explore additional risk factors that can compromise the laboring patient and fetus or fetuses, and Part 4 will review neonatal conditions that require prompt recognition and stabilization.\r\nPlease note: Completing this learning activity does not authorize you to add any skill discussed in the content to your practice if this function is not included in your current scope of practice.",
                "learning_objectives_html": "<p>After completing this learning activity, the participant should be able to:</p>\r\n<ul>\r\n    <li>Recognize that implicit or unconscious bias can impact decision-making in the clinical setting.</li>\r\n    <li>Identify the adverse health effects of hypertension, obesity, and diabetes for both the pregnant patient, developing fetus, and neonate.</li>\r\n    <li>Classify the stages of labor and explore how a fetal malposition or malpresentation can prolong or complicate labor.</li>\r\n    <li>Recognize how impaired oxygen delivery to the fetus can lead to hypoxic-ischemic encephalopathy (HIE).</li>\r\n    <li>Identify the presentation and stabilization of neonates with serious medical and surgical conditions.</li>\r\n    <li>Recognize fetal circulation and changes in circulation that should occur after birth with transition to extrauterine life.</li>\r\n</ul>\r\n<p><strong>Activity Planners and Authors</strong></p>\r\n<ul>\r\n    <li>Kristine A. Karlsen, PhD, APRN, NNP, FAAN (Author, Content Expert)</li>\r\n    <li>David Laumeyer, BSN, RN, CCRN, CFRN (Nurse Planner)</li>\r\n    <li>Emmanouil Kiriakopolous, DO (Course Director)</li>\r\n    <li>Amanda Pitt, MBA, BSN, RN, RN-BC, Lead Nurse Planner, HealthStream (Nurse Planner)</li>\r\n    <li>Evan McEwing, DNP, PHNA-BC, RN, CCRP, CHSE, Director, Content Development and Research, HealthStream (Content Reviewer)</li>\r\n    <li><span>Jessica Ellis, </span><span>RN, BSN, </span><span>Director, Content Development, </span>HealthStream (Content Reviewer)</li>\r\n    <li>Germaine Broussard, B.S., Sr. Development Manager, HealthStream (Content Reviewer)</li>\r\n    <li>Cor&rsquo;Shun Thurman, B.A., Accreditation Specialist, Accreditation, HealthStream (Content Reviewer)</li>\r\n    <li>Melissa Pickens, BBA, Accreditation Specialist, Accreditation, HealthStream (Content Reviewer)</li>\r\n</ul>\r\n<p>None of the planners for this educational activity have relevant financial relationship(s) to disclose with ineligible companies whose primary business is producing, marketing, selling, re-selling, or distributing healthcare products used by or on patients.</p>\r\n<p><strong>Commercial Support</strong></p>\r\n<p>This activity was not commercially supported.</p>",
                "course_outline_html": "<ul>\r\n    <li>Introduction to S.T.A.B.L.E. Foundations</li>\r\n    <li>Part 1: Factors that Impact Fetal Health</li>\r\n    <li>Part 2: Intrapartum Risk Factors</li>\r\n    <li>Part 3: Impaired Oxygen Delivery to the Fetus</li>\r\n    <li>Part 4: Neonatal Conditions</li>\r\n</ul>",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5F1EF3EC-628D-EF11-9992-005056A70B00",
                        "course_category_name": "HSTM - The S.T.A.B.L.E. Program Online 7th Edition Courses ONLY (Part of Curriculum)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "49D1E176-3574-EA11-A221-005056B14D10",
                        "course_category_name": "HSTM - The S.T.A.B.L.E. Program Online",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF64E5F4-3674-EA11-A221-005056B14D10",
                        "course_category_name": "The S.T.A.B.L.E. Program Online",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "496E0940-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CME - Continuing Medical Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1E8E3774-CEC9-E511-82AF-005056B150D3",
                        "course_category_name": "Diagnostic Tests & Examinations",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "EE06D56C-3874-EA11-A221-005056B14D10",
                        "course_category_name": "HSTM - The S.T.A.B.L.E. Program Online",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "975A148E-A6FF-E611-A64B-005056B1522B",
                        "course_category_name": "Obstetric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Midwife",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AFBFC50C-4AFE-11DE-ADE3-0015171C5BB3",
                        "course_category_name": "Online CME",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "74D008A2-F655-EF11-9990-005056A7327D",
                        "course_category_name": "HSTM - The S.T.A.B.L.E. Program Online - Instructor Bridge - (1 of 3 Courses for CURRICULUM OR ASSIGNMENT)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Obstetrics and Gynecology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Midwife",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DFE5D158-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE - Continuing Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A8BD2E52-FCDD-11DC-AFB4-0015171353BD",
                        "course_category_name": "Online CE",
                        "is_system_course_category": null
                    }
                ],
                // "ce_accreditation": {
                //    "accrediting_body_name": "ACCME; ANCC",
                //    "accreditation_statement": "<p><span style=\"font-size: 11pt; font-family: calibri, sans-serif;\">For licensed professionals who use CE Broker: HealthStream will automatically report your completion to CE Broker if your licensing board is listed. You must enter your license number, state, and discipline in your HealthStream profile for successful reporting. Other professionals may self-report the completion, if appropriate. </span></p>\r\n<p><img width=\"136\" height=\"115\" style=\"width: 136px; height: 115px;\" alt=\"HealthStream Reports to CE Broker within 24hrs\" src=\"https://www.healthstream.com/content/_CEBroker/CEBrokerReportsBadge-24Hrs.png\" /></p>",
                //    "course_level_accreditation_statement": "<p><strong>Physicians</strong><br />\r\nHealthStream, Inc. is accredited by the Accreditation Council for Continuing Medical Education (ACCME) to provide continuing medical education for physicians.<br />\r\n<br />\r\n</p>\r\n<p>HealthStream, Inc. designates this enduring material for a maximum of 2.25 AMA PRA Category 1 Credit(s)&trade;. Physicians should claim only the credit commensurate with the extent of their participation in the activity.<br />\r\n<br />\r\n<strong>Other Healthcare Providers</strong><br />\r\nThis activity was awarded AMA PRA Category 1 Credit(s)&trade;.</p>\r\n<p><strong>State Boards of Medicine</strong></p>\r\n<p>Florida Board of Medicine</p>\r\n<p>Florida Physicians Assistants</p>\r\n<p><strong>Nurses</strong></p>\r\n<p>HealthStream CNE Provider Unit is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation. ANCC Provider Number: P0088</p>\r\n<p>This activity is awarded 2.25 contact hour(s); 0.7 contact hours are in the area of pharmacology.</p>\r\n<p><strong>State Nursing Boards</strong></p>\r\n<p>Arkansas State Board of Nursing</p>\r\n<p>District of Columbia Board of Nursing</p>\r\n<p>Florida Board of Nursing</p>\r\n<p>Georgia Board of Nursing</p>\r\n<p>Michigan Board of Nursing</p>\r\n<p>New Mexico Board of Nursing</p>\r\n<p>North Dakota Board of Nursing</p>\r\n<p>South Carolina Board of Nursing</p>\r\n<p><em>CE Broker Tracking Number: 50-907</em></p>\r\n<p>Course Number: 20-1215150 <em>Category: </em>General</p>\r\n<p>*<em>Please note: Some boards will round the reported contact hours to the nearest 0.5 hour.<br />\r\n<br />\r\n</em></p>\r\n<p><strong>Respiratory Therapists</strong></p>\r\n<p>This program has been approved for 2.25 contact hours. Continuing Respiratory Care Education (CRCE) credit by the American Association for Respiratory Care, 9425, N. MacArthur Blvd, Suite 100, Irving TX 75063.</p>\r\n<p>Course Number: 193112000</p>",
                //    "credit_display_name": "CME; CNE",
                //    "credit_units": 2.25,
                //    "credit_unit_display_name": "<em>AMA PRA\r\nCategory I Credit(s)&trade;</em> ; Contact Hour(s)"
                //},
                "sub_courses": []
            },
            {
                "course_id": "EBED7D6E-A0FD-EE11-998C-005056A7F5E9",
                "course_version": 2,
                "name": "S.T.A.B.L.E. Program Bridge to the 7th Edition Training for Instructors",
                "course_type": 1,
                "author_information": "Kristine A. Karlsen, PhD, NNP-BC, FAAN, Neonatal Nurse Practitioner, S.T.A.B.L.E. Program Author and Founder, and S.T.A.B.L.E. Program Director.",
                "description": "The purpose of this course is to orient registered lead and support instructors to the new 7th Edition curriculum and the new S.T.A.B.L.E. Foundations course. Additionally, this course explains changes to student testing, updates to the instructor portal, and new requirements for submitting student rosters.",
                "learning_objectives_html": "<p>After completing this learning activity, the participant should be able to:</p>\r\n<ul>\r\n    <li>Orient registered Lead and Support Instructors to the new 7th Edition curriculum</li>\r\n    <li>Discuss the new S.T.A.B.L.E. Foundations module</li>\r\n    <li>Explain the changes to pre and post testing</li>\r\n    <li>Review the updated Instructor Portal and resources</li>\r\n    <li>Discuss how to enter a student roster and rules for student completion</li>\r\n    <li>Discuss how to maintain active instructor registration</li>\r\n</ul>\r\n<div>&nbsp;</div>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Midwife",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF64E5F4-3674-EA11-A221-005056B14D10",
                        "course_category_name": "The S.T.A.B.L.E. Program Online",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "49D1E176-3574-EA11-A221-005056B14D10",
                        "course_category_name": "HSTM - The S.T.A.B.L.E. Program Online",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "496E0940-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CME - Continuing Medical Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Obstetrics and Gynecology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A8BD2E52-FCDD-11DC-AFB4-0015171353BD",
                        "course_category_name": "Online CE",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "975A148E-A6FF-E611-A64B-005056B1522B",
                        "course_category_name": "Obstetric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1E8E3774-CEC9-E511-82AF-005056B150D3",
                        "course_category_name": "Diagnostic Tests & Examinations",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DC4CE665-F455-EF11-9990-005056A7327D",
                        "course_category_name": "HSTM - The S.T.A.B.L.E. Program Online - Instructor Bridge - (2 of 3 Courses for CURRICULUM ONLY)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AFBFC50C-4AFE-11DE-ADE3-0015171C5BB3",
                        "course_category_name": "Online CME",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DFE5D158-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE - Continuing Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Midwife",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            },
            {
                "course_id": "833282A6-3C54-EF11-998F-005056A7D719",
                "course_version": 1,
                "name": "Eligible Instructor Affidavit",
                "course_type": 1,
                "author_information": "Kristine A. Karlsen, PhD, NNP-BC, FAAN, Neonatal Nurse Practitioner, S.T.A.B.L.E. Program Author and Founder, and S.T.A.B.L.E. Program Director.",
                "description": "Participant affidavit of current instructor status.",
                "learning_objectives_html": "The purpose of this activity is to collect data on the participant&rsquo;s instructor status and ensure participants qualify for the S.T.A.B.L.E. 7th Ed. Instructor Bridge Training.",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "496E0940-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CME - Continuing Medical Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                        "course_category_name": "HealthStream",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DC4CE665-F455-EF11-9990-005056A7327D",
                        "course_category_name": "HSTM - The S.T.A.B.L.E. Program Online - Instructor Bridge - (2 of 3 Courses for CURRICULUM ONLY)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF64E5F4-3674-EA11-A221-005056B14D10",
                        "course_category_name": "The S.T.A.B.L.E. Program Online",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "CF20CB01-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Midwife",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician Assistant",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "49D1E176-3574-EA11-A221-005056B14D10",
                        "course_category_name": "HSTM - The S.T.A.B.L.E. Program Online",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "DFE5D158-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CE - Continuing Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "2FA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Obstetrics and Gynecology",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse Midwife",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Respiratory Therapist",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "1E8E3774-CEC9-E511-82AF-005056B150D3",
                        "course_category_name": "Diagnostic Tests & Examinations",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A8BD2E52-FCDD-11DC-AFB4-0015171353BD",
                        "course_category_name": "Online CE",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "975A148E-A6FF-E611-A64B-005056B1522B",
                        "course_category_name": "Obstetric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "AFBFC50C-4AFE-11DE-ADE3-0015171C5BB3",
                        "course_category_name": "Online CME",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                        "course_category_name": "Nurse",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E24BC24C-40B4-DF11-9F38-0015171C5BB1",
                        "course_category_name": "CNE - Continuing Nurse Education",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": null,
                    "accreditation_statement": null,
                    "course_level_accreditation_statement": null,
                    "credit_display_name": null,
                    "credit_units": null,
                    "credit_unit_display_name": null
                },
                "sub_courses": []
            }
        ]
    }
];